export const countriesDa = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albanien',
  DZ: 'Algeriet',
  AS: 'Amerikansk Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarktis',
  AG: 'Antigua og Barbuda',
  AR: 'Argentina',
  AM: 'Armenien',
  AW: 'Aruba',
  AU: 'Australien',
  AT: 'Østrig',
  AZ: 'Aserbajdsjan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Hviderusland',
  BE: 'Belgien',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnien-Hercegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brasilien',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgarien',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodja',
  CM: 'Cameroun',
  CA: 'Canada',
  CV: 'Kap Verde',
  KY: 'Cayman Islands',
  CF: 'Centralafrikanske republik',
  TD: 'Tchad',
  CL: 'Chile',
  CN: 'Kina',
  CX: 'Juleøen',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comorerne',
  CG: 'Congo',
  CD: 'Congo, Den Demokratiske Republik',
  CK: 'Cookøerne',
  CR: 'Costa Rica',
  CI: 'Elfenbenskysten',
  HR: 'Kroatien',
  CU: 'Cuba',
  CY: 'Cypern',
  CZ: 'Tjekkiet',
  DK: 'Danmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Den Dominikanske Republik',
  EC: 'Ecuador',
  EG: 'Egypten',
  SV: 'El Salvador',
  GQ: 'Ækvatorialguinea',
  ER: 'Eritrea',
  EE: 'Estland',
  ET: 'Etiopien',
  FK: 'Falklandsøerne (Malvinas)',
  FO: 'Færøerne',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'Frankrig',
  GF: 'Fransk Guyana',
  PF: 'Fransk Polynesien',
  TF: 'Franske sydlige territorier',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgien',
  DE: 'Tyskland',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Grækenland',
  GL: 'Grønland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island & Mcdonald Islands',
  VA: 'Vatikanstaten',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Ungarn',
  IS: 'Island',
  IN: 'Indien',
  ID: 'Indonesien',
  IR: 'Iran, Islamiske Republik',
  IQ: 'Irak',
  IE: 'Irland',
  IM: 'Isle Of Man',
  IL: 'Israel',
  IT: 'Italien',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kasakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Sydkorea',
  KW: 'Kuwait',
  KG: 'Kirgisistan',
  LA: 'Laos',
  LV: 'Letland',
  LB: 'Libanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyen',
  LI: 'Liechtenstein',
  LT: 'Litauen',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Makedonien',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldiverne',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshalløerne',
  MQ: 'Martinique',
  MR: 'Mauretanien',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Mikronesien, de fødererede stater',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongoliet',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marokko',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Holland',
  AN: '',
  NC: 'Ny Kaledonien',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Nordmarianerne',
  NO: 'Norge',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinsk territorium, besat',
  PA: 'Panama',
  PG: 'Papua Ny Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Filippinerne',
  PN: 'Pitcairn',
  PL: 'Polen',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Rumænien',
  RU: 'Den Russiske Føderation',
  RW: 'Rwanda',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts og Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin - Fransk',
  PM: 'Saint Pierre og Miquelon',
  VC: 'Saint Vincent og Grenadinerne',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome og Principe',
  SA: 'Saudi-Arabien',
  SN: 'Senegal',
  RS: 'Serbien',
  SC: 'Seychellerne',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakiet',
  SI: 'Slovenien',
  SB: 'Salomonøerne',
  SO: 'Somalia',
  ZA: 'Sydafrika',
  GS: 'South Georgia And Sandwich Isl.',
  ES: 'Spanien',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Surinam',
  SJ: 'Svalbard og Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sverige',
  CH: 'Schweiz',
  SY: 'Den syriske arabiske republik',
  TW: 'Taiwan',
  TJ: 'Tadsjikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TT: 'Trinidad og Tobago',
  TN: 'Tunesien',
  TR: 'Tyrkiet',
  TM: 'Turkmenistan',
  TC: 'Turks And Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis And Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  BQ: 'Bonaire',
  CW: 'Curacao',
  KP: 'Nordkorea',
  SS: 'Sydsudan',
  SX: 'Saint Martin - Hollandsk',
  TO: 'Tonga',
  XK: 'Kosovo',
} as const;
